export const TENANT_NAMES = [
  'ci',
  'arenaways',
  'twiliner',
  'velvet',
  'aguia',
  'sandbox-fs',
  'tifrance',
  'maas',
  'hellenictrain',
  'connectbus',
  'ltglink',
  'sandbox',
] as const;

export type TenantName = (typeof TENANT_NAMES)[number];

export type TenantOption = {
  value: string;
  label: string;
};
